import Footer from '../../common/components/List/Footer/index.js'
import {setLimit, setOffset} from './moListActions.js'
import {
  isLoadingSelector,
  moListQuerySelector,
  countSelector,
} from './moListSelectors.js'
import {useSelector} from '../../store.js'

export default function MOListFooter() {
  const params = useSelector(moListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)
  const count = useSelector(countSelector)

  return (
    <Footer
      isLoading={isLoading}
      limit={params.limit}
      offset={params.offset}
      count={count}
      setLimit={setLimit}
      setOffset={setOffset}
      preventResetOffset
    />
  )
}
